import { Link, useLocation } from "react-router-dom";
import { BrandMark } from "@/components/BrandMark";

export const Navbar = () => {
  const { pathname } = useLocation();
  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#333] bg-[#050505]/80 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-2 md:px-10">
        <Link to="/" data-testid="nav-logo" className="block">
          <BrandMark size="sm" />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          <Link
            to="/"
            data-testid="nav-drop"
            className={`font-mono-stamp text-xs transition-colors ${
              pathname === "/" ? "text-white" : "text-[#a0a0a0] hover:text-white"
            }`}
          >
            THE DROP
          </Link>
          <Link
            to="/find-your-fit"
            data-testid="nav-fyf"
            className={`font-mono-stamp text-xs transition-colors ${
              pathname === "/find-your-fit"
                ? "text-white"
                : "text-[#a0a0a0] hover:text-white"
            }`}
          >
            FIND YOUR FIT
          </Link>
          <a
            href="/#manifesto"
            data-testid="nav-manifesto"
            className="font-mono-stamp text-xs text-[#a0a0a0] transition-colors hover:text-white"
          >
            MANIFESTO
          </a>
          <a
            href="/#join"
            data-testid="nav-join"
            className="font-mono-stamp text-xs text-[#a0a0a0] transition-colors hover:text-white"
          >
            JOIN LIST
          </a>
        </nav>

        <Link
          to="/find-your-fit"
          data-testid="nav-cta"
          className="btn-brutal btn-brutal-solid !py-2 !px-4 !text-[10px]"
        >
          GET SIZED →
        </Link>
      </div>
    </header>
  );
};
